export default "__VITE_ASSET__DPxdr5cO__"